<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
    <empty-state
      :title="$t('INBOX_MGMT.FINISH.TITLE')"
      :message="message"
    >
      <div class="w-full text-center">
        <indiamart-webhook-url
          v-if="isAnIndiamartInbox"
          :webhook-url="currentInbox.callback_webhook_url"
          show-heading
          wide
        />
        <div class="flex justify-center gap-2 mt-4">
          <router-link
            class="button success"
            :to="{
              name: 'inbox_dashboard',
              params: { inboxId: this.$route.params.inbox_id },
            }"
          >
            {{ $t('INBOX_MGMT.FINISH.BUTTON_TEXT') }}
          </router-link>
        </div>
      </div>
    </empty-state>
  </div>
</template>

<script>
import EmptyState from '../../../../components/widgets/EmptyState';
import IndiamartWebhookUrl from './components/IndiamartWebhookUrl';

export default {
  components: {
    EmptyState,
    IndiamartWebhookUrl,
  },
  computed: {
    currentInbox() {
      return this.$store.getters['inboxes/getInbox'](
        this.$route.params.inbox_id
      );
    },
    isAnIndiamartInbox() {
      return this.currentInbox.channel_type === 'Channel::Indiamart';
    },
    message() {
      if (this.isAnIndiamartInbox) {
        return `${this.$t('INBOX_MGMT.FINISH.MESSAGE')}. ${this.$t(
          'INBOX_MGMT.ADD.INDIAMART_CHANNEL.API_CALLBACK.SUBTITLE'
        )}`;
      }

      return this.$t('INBOX_MGMT.FINISH.MESSAGE');
    },
  },
};
</script>
